module.exports = {
	"pt": {
		"ui.about.title.overview": "Mapas Humanitários recentes",
		"ui.about.subhead": "",
		"ui.about.overview": "",
		"ui.about.title.getting_started": "Como Começar",
		"ui.about.getting_started": "",
		"ui.exports": "Exportações",
		"ui.exports.title": "Exportações",
		"ui.help": "Ajuda",
		"ui.login": "Entrar",
		"ui.about.license": "",
		"ui.about.license.odbl": "liceciado sob ODbL 1.0",
		"ui.aoi_toolbar.tools": "",
		"ui.draw.box": "",
		"ui.draw.draw": "",
		"ui.draw.import": "",
		"ui.draw.current_view": "",
		"ui.authorized.thank_you": "",
		"configuration.description.label": "Descrição",
		"ui.configuration.description.label": "Descrição",
		"export.description.label": "Descrição",
		"exports.description.label": "Descrição",
		"configuration.description.placeholder": "",
		"configuration.feature_selection.label": "",
		"configuration.name.label": "Nome",
		"ui.configuration.name.label": "Nome",
		"export.name.label": "Nome",
		"exports.name.label": "Nome",
		"configuration.name.placeholder": "",
		"configuration.public.description": "",
		"ui.configuration.update": "",
		"ui.configuration.create": "",
		"ui.configuration.delete": "",
		"ui.configuration.title": "",
		"configuration.title": "",
		"ui.configurations": "",
		"ui.configuration.tables.label": "",
		"ui.configuration.owner.label": "Proprietário",
		"exports.owner.label": "Proprietário",
		"export.project.label": "Projeto",
		"exports.project.label": "Projeto",
		"export.area.label": "",
		"export.area": "",
		"export.created_at.label": "",
		"export.created_by.label": "",
		"export.published.label": "Publicado",
		"yes": "",
		"no": "",
		"export.export_formats.label": "",
		"export.osma.label": "",
		"ui.view_this_area": "",
		"ui.exports.status": "",
		"ui.exports.started": "",
		"ui.exports.finished": "",
		"ui.exports.duration": "",
		"ui.exports.features": "Elementos",
		"ui.exports.rerun_export": "",
		"ui.exports.clone_export": "Clonar Exportação",
		"ui.exports.feature_selection.title": "Seleção de Elementos",
		"export.feature_selection.label": "Seleção de Elementos",
		"ui.close": "Fechar",
		"export.errors.the_geom.too_large": "",
		"export.buffer_aoi.description": "",
		"export.name.placeholder": "",
		"export.project.placeholder": "",
		"export.published.description": "",
		"export.tag_tree_search.placeholder": "",
		"nav.next": "",
		"export.feature_selection.load_from_josm_preset": "",
		"ui.clear": "",
		"configuration.load_yaml": "",
		"ui.exports.tag_tree": "",
		"ui.exports.stored_configuration": "",
		"ui.exports.create_export": "Criar Exportação",
		"ui.exports.describe_export": "Descreva a Exportação",
		"ui.exports.choose_formats": "",
		"ui.exports.select_features": "",
		"ui.exports.summary": "",
		"ui.overpass_last_updated": "",
		"ui.show_on_map": "",
		"exports.created.label": "Criado",
		"ui.settings": "",
		"ui.never": "",
		"exports.schedule.6hrs": "",
		"exports.schedule.daily": "",
		"exports.schedule.weekly": "",
		"exports.schedule.monthly": "",
		"ui.unknown": "",
		"ui.untitled": "",
		"runs.last_run.label": "",
		"runs.next_run.label": "",
		"runs.schedule.label": "",
		"ui.private": "Privado",
		"ui.search.only_mine": "",
		"ui.search.placeholder": "",
		"ui.search": "Procurar",
		"ui.login_to_osm": "Autenticar no OpenStreetMap",
		"ui.hot.title": "Equipa OpenStreetMap Humanitária",
		"ui.toggle_navigation": "",
		"ui.osm_export_tool.title": "Ferramenta de Exportação HOT",
		"ui.create": "Criar",
		"ui.hdx": "",
		"ui.about": "Sobre",
		"ui.log_out": "Sair",
		"ui.log_in": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales/pt.json
// module id = 1497
// module chunks = 1